export const ERROR_FRAGMENT = `{
  type
  message
}`
